import React, { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import CountrySelector from "./CountrySelector";
import StateSelector from "./StateSelector";
import CitySelector from "./CitySelector";

const CountryStateCity = ({
  onChange,
  initialCountry,
  initialState,
  initialCity,
}) => {
  const [selectedCountry, setSelectedCountry] = useState(initialCountry);
  const [selectedState, setSelectedState] = useState(initialState);
  const [selectedCity, setSelectedCity] = useState(initialCity);

  // Sync with initialCountry changes
  useEffect(() => {
    setSelectedCountry(initialCountry);
  }, [initialCountry]);

  // Unified change handler
  const handleChange = (type, value) => {
    const newState = {
      country: selectedCountry,
      state: selectedState,
      city: selectedCity,
      [type]: value,
    };

    if (type === "country") {
      newState.state = null;
      newState.city = null;
    }
    if (type === "state") {
      newState.city = null;
    }

    setSelectedCountry(newState.country);
    setSelectedState(newState.state);
    setSelectedCity(newState.city);
    onChange?.(newState);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <CountrySelector
          selectedCountry={selectedCountry}
          onChange={(val) => handleChange("country", val)}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <StateSelector
          countryCode={selectedCountry?.code}
          selectedState={selectedState}
          onChange={(val) => handleChange("state", val)}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <CitySelector
          countryCode={selectedCountry?.code}
          stateCode={selectedState?.code}
          selectedCity={selectedCity}
          onChange={(val) => handleChange("city", val)}
        />
      </Grid>
    </Grid>
  );
};

export default React.memo(CountryStateCity);
